import { render } from "./AppBreadcrumbs.vue?vue&type=template&id=346e945e"
import script from "./AppBreadcrumbs.vue?vue&type=script&lang=js"
export * from "./AppBreadcrumbs.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__